import { Card, Flex, Table } from 'antd'

import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { ImportMedicines } from '../components'
import { useTableConfig } from '../hooks'

export const MedicinesRegisterPage = () => {
  const { t } = useLocales()

  const { columns, dataSource } = useTableConfig()

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.medicines_register')
        }
      ]}
      title={t('medicine_register.title')}
    >
      <Card>
        <Flex vertical gap={16}>
          <Flex justify="flex-end">
            <ImportMedicines />
          </Flex>

          <Table
            rowKey="title"
            bordered
            columns={columns}
            dataSource={dataSource}
            scroll={{ x: 'max-content' }}
            pagination={false}
          />
        </Flex>
      </Card>
    </PageBreadcrumbs>
  )
}
